import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, message, Space } from 'antd'
import EntranceForm from '../../organism/entrance/EntranceForm'
import { ECompleteMethod, EEntranceOption } from '../tracking/type'
import PickupLocationForm from '../../organism/pickupLocation/PickupLocationForm'
import { putDeliveryComplete } from '../../../api/shippingApi'
import { useDeliveryInfo } from '../../../api/useDeliveryInfo'
import { useNavigate, useParams } from 'react-router-dom'
import { showMessageWithTitle } from '../../../common/message'
import styles from "../entranceInfo/entranceScreen.module.css";

export const PickupLocationScreen = () => {
  const { t } = useTranslation(['location'])
  const boxRef = useRef('')
  const boxPassRef = useRef('')
  const completeInfo = useRef('')
  const entranceCodeRef = useRef('')
  const entranceRef = useRef<EEntranceOption>()
  const [messageApi, messageHolder] = message.useMessage()

  const completeMethodRef = useRef<ECompleteMethod>(ECompleteMethod.DOOR)

  const { tracking } = useParams()
  const { deliveryInfo } = useDeliveryInfo(tracking)
  const navigate = useNavigate()

  const handleSaveResult = () => {
    putDeliveryComplete(
      messageApi,
      t,
      {
        entrance_option: entranceRef.current,
        entrance_password: entranceCodeRef.current,
        delivery_box_number: boxRef.current,
        delivery_box_password: boxPassRef.current,
        delivery_complete_on: completeMethodRef.current,
        delivery_complete_on_info: completeInfo.current,
      },
      tracking,
      () => {
        showMessageWithTitle(t('popup.success.entry.content'))
        navigate('/tracking/' + tracking)
      }
    )
  }

  return (
      <Space direction={'vertical'} size={20}>
          {messageHolder}
          <div className={'round-cntr info-container'}>
              <div className={'h2'}>{t('info.large.label')}</div>
              <div className={'body black45 preline ' + styles.label}>{t('info.label')}</div>
          </div>
          <EntranceForm
              info={deliveryInfo}
              isNight
              onEntrancePasswordChange={pass => (entranceCodeRef.current = pass)}
              onEntranceOptionChange={option => (entranceRef.current = option)}
          />
          <PickupLocationForm
              info={deliveryInfo}
              onBoxNumChange={value => (boxRef.current = value)}
              onBoxPasswordChange={pass => (boxPassRef.current = pass)}
              onCompleteMethodChange={method => (completeMethodRef.current = method)}
              onCompleteInfoChange={info => (completeInfo.current = info)}
          />
          <div className={'floating-btn-margin'}/>
          <Button
              type={'primary'}
              size={'large'}
              className={'floating-btn'}
              data-cy={'saveResult'}
              onClick={handleSaveResult}
          >
              {t('location.btn.save')}
          </Button>
      </Space>
  )
}
